import Cookies from "js-cookie";

import { safeJsonParse } from "../global/JsonHelper";

const TOKEN_COOKIE = "pnAccessToken";
const TOKEN_EXPIRY_HOURS = 1;

// js-cookie uses days, so 1 hour = 1/24
const cookieOptions = {
  expires: TOKEN_EXPIRY_HOURS / 24,
  // Only send over HTTPS. Falls back to false in dev so cookies still work over HTTP.
  secure: window.location.protocol === "https:",
  sameSite: "strict",
  path: "/",
};

/** Read and parse the auth token from the cookie. Returns null if absent or malformed. */
export function getToken() {
  const raw = Cookies.get(TOKEN_COOKIE);
  return raw ? safeJsonParse(raw) : null;
}

/** Persist the token as a secure cookie with a 1-hour sliding expiry. */
export function setToken(token) {
  Cookies.set(TOKEN_COOKIE, JSON.stringify(token), cookieOptions);
}

/** Remove the auth token cookie on logout. */
export function clearToken() {
  Cookies.remove(TOKEN_COOKIE, { path: "/" });
}

/** Returns true when a valid token cookie exists (browser auto-expires after 1 hr of inactivity). */
export function isAuthenticated() {
  return Boolean(getToken());
}

/**
 * Re-sets the cookie with a fresh 1-hour expiry.
 * Call this on each successful API response to implement a sliding session window.
 */
export function refreshTokenCookie() {
  const token = getToken();
  if (token) {
    setToken(token);
  }
}
